import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_config, fetch_link_by_id } from '../../api/configAPI'
import { fetch_announcement_by_id, create_new_announcement, update_announcement_by_id, delete_announcement_by_id } from '../../api/announcementAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import notify from '../../utils/IANotification';
import JoditEditor from 'jodit-react';
import Switch from "react-switch";
import FileUploadField from '../../components/FileUploadField';
import SubNavbar from '../../components/ui/SubNavbar';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { MdArrowBack, MdSave, MdDelete, MdEvent, MdLink, MdNotificationsActive, MdArticle } from 'react-icons/md';

export default function AnnouncementFormPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  let user_data = useFetchUserData()
  let announcement_id = new URLSearchParams(window.location.search).get("announcement_id")

  const [activeTab, setActiveTab] = useState("general")
  const [showEventSection, setShowEventSection] = useState(false)
  const [announcementFormData, setAnnouncementFormData] = useState({
    title: "",
    description: "",
    start_datetime: "",
    end_datetime: "",
    is_forever: 0,
    service_type_id: [],
    link_id: "",
    channels: ["bulletin", "announcement"],
    link_name: "",
    link_url: "",
    is_member_news: 0,
    is_popup: 0,
    persistent: 0,
    popup_summary: "",
    event_name: "",
    event_description: "",
    event_start_datetime: "",
    event_end_datetime: "",
    event_location: "",
    event_id: null,
  })

  const [, setLinkFormData] = useState({
    link_name: "",
    link_url: "",
    link_type: "",
    is_public: 1,
  })

  const editor = useRef(null);
  const placeholder = "Start typing announcement content...";
  const [serviceSettings, setServiceSettings] = useState([])

  const tabs = [
    { id: 'general', label: 'General Info' },
    { id: 'audience', label: 'Audience & Scope' },
    { id: 'event', label: 'Linked Event' },
    { id: 'popup_links', label: 'Popup & Links' },
    { id: 'content', label: 'Announcement Content' },
  ]

  const liveConfig = {
    height: 450,
    placeholder,
    buttons: [
      'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript',
      'ul', 'ol', 'outdent', 'indent', 'font', 'fontsize', 'brush', 'paragraph',
      'table', 'link', 'undo', 'redo', 'eraser', 'copyformat'
    ],
    askBeforePasteHTML: false,
    hotkeys: {
      redo: 'ctrl+z',
      undo: 'ctrl+y,ctrl+shift+z',
      indent: 'ctrl+]',
      outdent: 'ctrl+[',
      bold: 'ctrl+b',
      italic: 'ctrl+i',
    },
  };

  const fetchAnnouncementById = async () => {
    if (announcement_id && announcement_id !== "new") {
      const data = await fetch_announcement_by_id(announcement_id)
      if (data?.status === 200) {
        setAnnouncementFormData(data.data)
      } else {
        notify({ type: "error", message: "Failed to fetch announcement data" })
      }
    }
  }

  const createAnnouncement = async () => {
    const data = await create_new_announcement(announcementFormData)
    if (data?.status === 200) {
      notify({ type: "success", message: "Announcement created successfully" })
      navigate("/admin/announcements/details?announcement_id=" + data.data.id)
    } else {
      notify({ type: "error", message: "Failed to create announcement" })
    }
  }

  const updateAnnouncement = async () => {
    if (!announcement_id || announcement_id === "new") return
    const data = await update_announcement_by_id(announcement_id, announcementFormData)
    if (data?.status === 200) {
      notify({ type: "success", message: "Announcement updated successfully" })
    } else {
      notify({ type: "error", message: "Failed to update announcement" })
    }
  }

  const handle_form_submit = (e) => {
    if (e) e.preventDefault()
    if (announcement_id && announcement_id !== "new") {
      updateAnnouncement()
    } else {
      createAnnouncement()
    }
  }

  const deleteAnnouncement = async () => {
    if (!announcement_id || announcement_id === "new") return
    const data = await delete_announcement_by_id(announcement_id)
    if (data?.status === 200) {
      notify({ type: "success", message: "Announcement deleted successfully" })
      navigate("/admin/announcements")
    } else {
      notify({ type: "error", message: "Failed to delete announcement" })
    }
  }

  const fetchLinkById = async () => {
    if (!announcementFormData?.link_id) return;
    let data = await fetch_link_by_id(announcementFormData?.link_id);
    if (data?.status === 200) {
      setLinkFormData(data.data);
    }
  };

  const fetchConfigSettings = async () => {
    let data = await fetch_config();
    if (data?.status === 200) {
      setServiceSettings(data.data.services || []);
    } else {
      notify({ type: "error", message: "Failed to fetch config settings" });
    }
  };

  useEffect(() => {
    fetchAnnouncementById()
    fetchConfigSettings()
  }, [])

  useEffect(() => {
    fetchLinkById()
  }, [announcementFormData?.link_id])

  return (
    <AdminLayout
      navSelected={"Announcements"}
      headerText={announcement_id === "new" ? "New Announcement" : "Edit Announcement"}
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/announcements')}>
              Back
            </Button>
            <h1 className='text-xl font-bold text-gray-900'>
              {announcement_id === "new" ? "Create Announcement" : announcementFormData.title || "Edit Announcement"}
            </h1>
          </div>
          <div className="flex items-center gap-3">
            {announcement_id && announcement_id !== "new" && (
              <Button variant="danger" icon={MdDelete} onClick={deleteAnnouncement}>
                Delete
              </Button>
            )}
            <Button variant="primary" icon={MdSave} onClick={handle_form_submit}>
              {announcement_id === "new" ? "Create" : "Save Changes"}
            </Button>
          </div>
        </>
      }
    >
      {/* SubNavbar */}
      <SubNavbar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {/* TAB 1: GENERAL INFO */}
      {activeTab === "general" && (
        <Card title="General Information" subtitle="Configure title, publication schedule, and cover graphics.">
          {announcementFormData?.file_data?.ext_file_path && (
            <div className="mb-4">
              <img
                src={config.endpoint + announcementFormData?.file_data?.ext_file_path}
                alt="Announcement Header"
                className="w-full max-w-lg h-56 object-cover rounded-xl border border-gray-200"
              />
            </div>
          )}

          {announcement_id && announcement_id !== "new" && (
            <div className="mb-6">
              <FileUploadField
                upload_url={config.endpoint + "/file/announcements/" + announcement_id}
                max_files={1}
                max_file_size={1}
                onChange={() => fetchAnnouncementById()}
                text={"Upload Cover Graphic"}
              />
            </div>
          )}

          <div className="space-y-6">
            <div className="input-container">
              <label className="input-label font-semibold">Announcement Title</label>
              <input
                type="text"
                className="text-input"
                placeholder="e.g. Annual General Meeting Notice"
                value={announcementFormData.title || ""}
                onChange={(e) => setAnnouncementFormData({ ...announcementFormData, title: e.target.value })}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Publication Start Date</label>
                <input
                  type="date"
                  className="text-input"
                  value={announcementFormData.start_datetime?.split("T")[0] || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, start_datetime: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Publication End Date</label>
                <input
                  type="date"
                  className="text-input"
                  disabled={announcementFormData.is_forever === 1}
                  value={announcementFormData.end_datetime?.split("T")[0] || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, end_datetime: e.target.value })}
                />
              </div>
            </div>

            <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-xl border border-gray-200">
              <Switch
                checked={announcementFormData.is_forever === 1}
                onChange={(checked) => setAnnouncementFormData({ ...announcementFormData, is_forever: checked ? 1 : 0 })}
              />
              <span className="text-xs font-semibold text-gray-700">
                No Expiry Date (Always Visible)
              </span>
            </div>
          </div>
        </Card>
      )}

      {/* TAB 2: AUDIENCE & SCOPE */}
      {activeTab === "audience" && (
        <Card title="Target Audience &amp; Service Profiles" subtitle="Select which congregation service profiles will display this announcement.">
          <div className="space-y-6">
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div>
                <label className="font-semibold text-sm text-gray-900">Member News Flag</label>
                <p className="text-xs text-gray-500">Flag this announcement specifically for registered church members.</p>
              </div>
              <Switch
                checked={announcementFormData.is_member_news === 1}
                onChange={(checked) => setAnnouncementFormData({ ...announcementFormData, is_member_news: checked ? 1 : 0 })}
              />
            </div>

            <div>
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div>
                  <label className="font-semibold text-sm text-gray-900 block">Service Profiles Scope</label>
                  <p className="text-xs text-gray-500 mt-0.5">Select which congregation service profiles will display this announcement.</p>
                </div>
                {serviceSettings?.length > 0 && (
                  <div className="flex items-center gap-2.5">
                    <span className="text-xs font-medium text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
                      {serviceSettings.filter(s => announcementFormData?.service_type_id?.includes(s.id)).length} of {serviceSettings.length} selected
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        const currentSelected = announcementFormData?.service_type_id || [];
                        const availableIds = serviceSettings.map((s) => s.id);
                        const updated = Array.from(new Set([...currentSelected, ...availableIds]));
                        setAnnouncementFormData({
                          ...announcementFormData,
                          service_type_id: updated,
                        });
                      }}
                      className="text-xs font-semibold text-blue-600 hover:text-blue-800 hover:underline cursor-pointer transition-colors"
                    >
                      Select All
                    </button>
                    <span className="text-gray-300">|</span>
                    <button
                      type="button"
                      onClick={() => {
                        const currentSelected = announcementFormData?.service_type_id || [];
                        const idsToRemove = new Set(serviceSettings.map((s) => s.id));
                        setAnnouncementFormData({
                          ...announcementFormData,
                          service_type_id: currentSelected.filter((id) => !idsToRemove.has(id)),
                        });
                      }}
                      className="text-xs font-semibold text-gray-500 hover:text-gray-700 hover:underline cursor-pointer transition-colors"
                    >
                      Deselect All
                    </button>
                  </div>
                )}
              </div>
              {serviceSettings?.length === 0 ? (
                <p className="text-xs text-gray-400 italic">No service profiles available in your scope.</p>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {serviceSettings.map((service) => {
                    const isSelected = announcementFormData?.service_type_id?.includes(service.id)
                    return (
                      <div key={service.id} className="flex items-center justify-between p-3.5 bg-gray-50 rounded-xl border border-gray-200">
                        <span className="text-xs font-bold text-gray-900">{service.name}</span>
                        <Switch
                          checked={isSelected}
                          onChange={(checked) => {
                            let newServiceTypes = [...(announcementFormData.service_type_id || [])]
                            if (checked) {
                              if (!newServiceTypes.includes(service.id)) newServiceTypes.push(service.id)
                            } else {
                              newServiceTypes = newServiceTypes.filter(item => item !== service.id)
                            }
                            setAnnouncementFormData({ ...announcementFormData, service_type_id: newServiceTypes })
                          }}
                        />
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </div>
        </Card>
      )}

      {/* TAB 3: LINKED EVENT */}
      {activeTab === "event" && (
        <Card
          title="Linked Church Event"
          subtitle="Optionally link a church event registration page or event schedule to this announcement."
          headerRight={
            !(announcementFormData.event_id || showEventSection) && (
              <Button variant="primary" icon={MdEvent} onClick={() => setShowEventSection(true)}>
                Add Event Details
              </Button>
            )
          }
        >
          {!(announcementFormData.event_id || showEventSection) ? (
            <div className="text-center py-12 text-gray-400">
              <MdEvent size={48} className="mx-auto text-gray-300 mb-2" />
              <p className="text-sm font-medium">No event linked to this announcement.</p>
            </div>
          ) : (
            <div className="space-y-6">
              <div className="input-container">
                <label className="input-label font-semibold">Event Name</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="e.g. Easter Celebration Service"
                  value={announcementFormData.event_name || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, event_name: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Event Description</label>
                <textarea
                  className="textarea-input h-32"
                  placeholder="Brief overview of event activities and registration guidelines..."
                  value={announcementFormData.event_description || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, event_description: e.target.value })}
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="input-container">
                  <label className="input-label font-semibold">Event Start Date &amp; Time</label>
                  <input
                    type="datetime-local"
                    className="text-input"
                    value={announcementFormData.event_start_datetime || ""}
                    onChange={(e) => setAnnouncementFormData({ ...announcementFormData, event_start_datetime: e.target.value })}
                  />
                </div>

                <div className="input-container">
                  <label className="input-label font-semibold">Event End Date &amp; Time</label>
                  <input
                    type="datetime-local"
                    className="text-input"
                    value={announcementFormData.event_end_datetime || ""}
                    onChange={(e) => setAnnouncementFormData({ ...announcementFormData, event_end_datetime: e.target.value })}
                  />
                </div>
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Event Location</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="e.g. Main Sanctuary, Level 2"
                  value={announcementFormData.event_location || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, event_location: e.target.value })}
                />
              </div>

              {announcementFormData?.event_id && (
                <div className="pt-2">
                  <Button
                    variant="outline"
                    icon={MdArticle}
                    onClick={() => navigate("/admin/events/details?event_id=" + announcementFormData.event_id)}
                  >
                    Open Linked Event Manager Page
                  </Button>
                </div>
              )}
            </div>
          )}
        </Card>
      )}

      {/* TAB 4: POPUP & LINKS */}
      {activeTab === "popup_links" && (
        <Card title="Call-to-Action Links &amp; Popup Banners" subtitle="Configure external URL buttons and website splash popups.">
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Call-to-Action Button Label</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="e.g. Contact Organizer / Register Here"
                  value={announcementFormData.link_name || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, link_name: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Button Action Target URL</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="e.g. https://forms.gle/... or tel:81234567"
                  value={announcementFormData.link_url || ""}
                  onChange={(e) => setAnnouncementFormData({ ...announcementFormData, link_url: e.target.value })}
                />
              </div>
            </div>

            <div className="pt-4 border-t border-gray-100 space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                <div>
                  <label className="font-semibold text-sm text-gray-900 flex items-center gap-2">
                    <MdNotificationsActive size={18} className="text-amber-500" />
                    Enable Popup Announcement Banner
                  </label>
                  <p className="text-xs text-gray-500">Displays a pop-up modal when users land on the homepage.</p>
                </div>
                <Switch
                  checked={announcementFormData?.is_popup === 1}
                  onChange={(checked) => setAnnouncementFormData({ ...announcementFormData, is_popup: checked ? 1 : 0 })}
                />
              </div>

              {announcementFormData?.is_popup === 1 && (
                <div className="space-y-4 p-4 bg-gray-50/50 border border-gray-200 rounded-2xl">
                  <div className="flex items-center justify-between">
                    <div>
                      <label className="font-semibold text-xs text-gray-900">Persistent Popup</label>
                      <p className="text-[11px] text-gray-500">Repeats pop-up display on every homepage visit.</p>
                    </div>
                    <Switch
                      checked={announcementFormData?.persistent === 1}
                      onChange={(checked) => setAnnouncementFormData({ ...announcementFormData, persistent: checked ? 1 : 0 })}
                    />
                  </div>

                  <div className="input-container">
                    <label className="input-label font-semibold">Popup Teaser Summary (Max 120 chars)</label>
                    <textarea
                      className="textarea-input h-20"
                      placeholder="Short summary preview for homepage popup..."
                      value={announcementFormData?.popup_summary || ""}
                      onChange={(e) => {
                        if (e.target.value.length > 120) return
                        setAnnouncementFormData({ ...announcementFormData, popup_summary: e.target.value })
                      }}
                    />
                    <p className={`text-xs text-right mt-1 ${announcementFormData?.popup_summary?.length >= 120 ? "text-red-500 font-bold" : "text-gray-400"}`}>
                      {announcementFormData?.popup_summary?.length || 0}/120
                    </p>
                  </div>

                  {announcement_id && announcement_id !== "new" && (
                    <div>
                      <FileUploadField
                        upload_url={config.endpoint + "/file/announcements/popup/" + announcement_id}
                        max_files={1}
                        max_file_size={1}
                        onChange={() => fetchAnnouncementById()}
                        text={"Upload Popup Banner Graphic"}
                        subtext={"Portrait ratio recommended (e.g. 1080 x 1920 pixels)"}
                        item_index={"popup_image"}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Card>
      )}

      {/* TAB 5: ANNOUNCEMENT CONTENT */}
      {activeTab === "content" && (
        <Card title="Announcement Body Content" subtitle="Use the rich text editor to compose full announcement text.">
          <div className="space-y-4">
            <JoditEditor
              ref={editor}
              value={announcementFormData.description || ""}
              config={liveConfig}
              tabIndex={1}
              onBlur={newContent => {
                setAnnouncementFormData({ ...announcementFormData, description: newContent })
              }}
            />
          </div>
        </Card>
      )}
    </AdminLayout>
  )
}
